import { ReactNode } from "react"
import Button from "@/components/Button"
import DashboardTopbar from "@/components/DashboardTopbar"
import { PlusIcon } from "@heroicons/react/20/solid"
import AppLayout from "@/layouts/AppLayout"
import EventsList from "@/components/EventsList"
import { Modals, useModals } from "@/hooks/useModals"
import AddEventModal from "@/modals/AddEventModal"

const EventsIndex = () => {
  const { openModal } = useModals()

  return (
    <>
      <DashboardTopbar title="Events">
        <Button size="sm" onClick={() => openModal(Modals.AddEvent)}>
          <PlusIcon className="h-5 w-5" />
          <span>Add event</span>
        </Button>
      </DashboardTopbar>

      <EventsList />

      <AddEventModal />
    </>
  )
}

EventsIndex.layout = (page: ReactNode) => <AppLayout>{page}</AppLayout>

export default EventsIndex
